module.exports = {
  interestQuestionnaireComponentEvents: {
    InterestQuestionnaireEntry: {
      code: 'Stepper',
      events: {
        IqEntryPageLoad: {
          description: 'Triggered when the stepper (entry) page is viewed.',
          eventHub: {
            code: 'OnLoad',
            action: 'InterestQuiz_Stepper_OnLoad'
          }
        },
        IqEntryOnClickCta: {
          description: 'Triggered when the CTA button is clicked on the stepper (entry) page.',
          eventHub: {
            code: 'OnClickCta',
            action: 'InterestQuiz_Stepper_OnClickCta'
          }
        }
      }
    },
    InterestQuestionnaireAttributeQuiz: {
      code: 'Question',
      events: {
        IqQuestionPageOnLoad: {
          description: 'Triggered when a question page is viewed.',
          eventHub: {
            code: 'OnLoad',
            action: 'InterestQuiz_Question_OnLoad',
            dataKeys: ['questionId']
          }
        },
        IqQuestionOnClickYes: {
          description: "Triggered when the 'Yes' answer button is clicked on the question page.",
          eventHub: {
            code: 'OnClickYes',
            action: 'InterestQuiz_Question_OnClickYes',
            dataKeys: ['questionId']
          }
        },
        IqQuestionOnClickNo: {
          description: "Triggered when the 'No' answer button is clicked on the question page.",
          eventHub: {
            code: 'OnClickNo',
            action: 'InterestQuiz_Question_OnClickNo',
            dataKeys: ['questionId']
          }
        },
        IqQuestionOnClickBack: {
          description: 'Triggered when the back navigation button is clicked on the question page.',
          eventHub: {
            code: 'OnClickBack',
            action: 'InterestQuiz_Question_OnClickBack',
            dataKeys: ['questionId']
          }
        },
        IqQuestionOnClickNext: {
          description: 'Triggered when the next navigation button is clicked on the question page.',
          eventHub: {
            code: 'OnClickNext',
            action: 'InterestQuiz_Question_OnClickNext',
            dataKeys: ['questionId']
          }
        }
      }
    },
    InterestQuestionnaireEmail: {
      code: 'Email',
      events: {
        IqEmailPageOnLoad: {
          description: 'Triggered when the email collection page is viewed.',
          eventHub: {
            code: 'OnLoad',
            action: 'InterestQuiz_Email_OnLoad'
          }
        },
        IqEmailOnClickCta: {
          description: 'Triggered when the email collection page CTA button is clicked.',
          eventHub: {
            code: 'OnClickCta',
            action: 'InterestQuiz_Email_OnClickCta',
            dataKeys: ['email']
          }
        }
      }
    },
    InterestQuestionnaireCareers: {
      code: 'Results',
      events: {
        IqResultsPageOnLoad: {
          description: 'Triggered when the results page is viewed.',
          eventHub: {
            code: 'OnLoad',
            action: 'InterestQuiz_Results_OnLoad'
          }
        },
        IqResultsCareerOnClickBack: {
          description: 'Triggered when the back career navigation button is clicked.',
          eventHub: {
            code: 'OnClickBack',
            action: 'InterestQuiz_Results_OnClickBack',
            dataKeys: ['careerId']
          }
        },
        IqResultsCareerOnClickNext: {
          description: 'Triggered when the next career navigation button is clicked.',
          eventHub: {
            code: 'OnClickNext',
            action: 'InterestQuiz_Results_OnClickNext',
            dataKeys: ['careerId']
          }
        },
        IqResultsCareerOnClickCta: {
          description: "Triggered when the CTA button 'See top schools' is clicked.",
          eventHub: {
            code: 'OnClickCta',
            action: 'InterestQuiz_Results_OnClickCta',
            dataKeys: ['careerId']
          }
        },
        IqResultsFeedbackOnClickYes: {
          description: "Triggered when the 'Yes' feedback button is clicked.",
          eventHub: {
            code: 'OnClickYes',
            action: 'InterestQuiz_Results_OnClickYes'
          }
        },
        IqResultsFeedbackOnClickNo: {
          description: "Triggered when the 'No' feedback button is clicked.",
          eventHub: {
            code: 'OnClickNo',
            action: 'InterestQuiz_Results_OnClickNo'
          }
        }
      }
    }
  }
};
